import { useEffect, useState } from "react";
import { applyConsent, getConsent, setConsent, OPEN_PREFERENCES_EVENT } from "@/lib/consent";

// Aviso de cookies. Recusar é tão fácil quanto aceitar, nada vem marcado e a
// escolha pode ser mudada a qualquer hora ("Preferências de cookies" no rodapé
// da landing e na Política de Privacidade).
export default function CookieConsent() {
  // Começa fechado e decide depois de montar: a landing é pré-renderizada no build
  // (react-snap) sem o cookie de escolha, e o primeiro render precisa bater com ela.
  const [open, setOpen] = useState(false);
  const [details, setDetails] = useState(false);
  const [analytics, setAnalytics] = useState(false);

  useEffect(() => {
    if (navigator.userAgent.includes("ReactSnap")) return;   // pré-renderização do build
    const c = getConsent();
    setOpen(!c);
    setAnalytics(!!c?.analytics);
    applyConsent();
    const reopen = () => {
      setAnalytics(!!getConsent()?.analytics);
      setDetails(true);
      setOpen(true);
    };
    window.addEventListener(OPEN_PREFERENCES_EVENT, reopen);
    return () => window.removeEventListener(OPEN_PREFERENCES_EVENT, reopen);
  }, []);

  if (!open) return null;

  const choose = (value) => {
    setConsent({ analytics: value });
    setOpen(false);
    setDetails(false);
  };

  return (
    <div
      role="dialog"
      aria-modal="false"
      aria-labelledby="cookie-consent-title"
      className="fixed inset-x-0 bottom-0 z-[100] p-3 sm:p-4"
      data-testid="cookie-consent"
    >
      <div className="mx-auto max-w-3xl rounded-2xl border border-neutral-300 bg-white text-neutral-900 shadow-2xl p-4 sm:p-5">
        <h2 id="cookie-consent-title" className="text-sm font-semibold">Cookies neste site</h2>
        <p className="mt-1 text-sm text-neutral-700 leading-relaxed">
          Usamos cookies essenciais para o login e para guardar esta escolha. Com a sua permissão, usamos também
          cookies de análise (PostHog) para entender como o site é usado e melhorar o produto. Detalhes na{" "}
          <a href="/privacidade" className="underline text-emerald-800 font-medium">Política de Privacidade</a>.
        </p>

        {details && (
          <fieldset className="mt-4 space-y-3 border-t border-neutral-200 pt-3">
            <legend className="sr-only">Categorias de cookies</legend>
            <label className="flex items-start gap-3 text-sm">
              <input type="checkbox" checked disabled className="mt-0.5" />
              <span>
                <strong>Essenciais</strong> (sempre ativos). Login, segurança e esta preferência. Sem eles o sistema não funciona.
              </span>
            </label>
            <label className="flex items-start gap-3 text-sm cursor-pointer">
              <input
                type="checkbox"
                checked={analytics}
                onChange={(e) => setAnalytics(e.target.checked)}
                className="mt-0.5"
                data-testid="cookie-analytics"
              />
              <span>
                <strong>Análise de uso</strong>. Páginas visitadas e cliques, para medir e melhorar o produto. Dentro do
                sistema nada do que aparece na tela é registrado.
              </span>
            </label>
          </fieldset>
        )}

        <div className="mt-4 flex flex-wrap gap-2 justify-end">
          {details ? (
            <button
              type="button"
              onClick={() => choose(analytics)}
              className="rounded-full bg-emerald-800 hover:bg-emerald-900 text-white text-sm font-medium px-4 py-2"
              data-testid="cookie-save"
            >
              Salvar escolha
            </button>
          ) : (
            <button
              type="button"
              onClick={() => setDetails(true)}
              className="rounded-full border border-neutral-400 hover:border-neutral-700 text-sm font-medium px-4 py-2"
              data-testid="cookie-customize"
            >
              Personalizar
            </button>
          )}
          <button
            type="button"
            onClick={() => choose(false)}
            className="rounded-full border border-neutral-400 hover:border-neutral-700 text-sm font-medium px-4 py-2"
            data-testid="cookie-reject"
          >
            Recusar não essenciais
          </button>
          <button
            type="button"
            onClick={() => choose(true)}
            className="rounded-full bg-emerald-800 hover:bg-emerald-900 text-white text-sm font-medium px-4 py-2"
            data-testid="cookie-accept"
          >
            Aceitar todos
          </button>
        </div>
      </div>
    </div>
  );
}
